import type { TournamentRoundsApi } from '@/v2/api/metadata/tournament-rounds'
import { buildFeedConfigTab } from '@/v2/kits/feed-config'
import { createTournamentRoundFeedConfigApi } from './round-feed-config-api'

/** Saves are inline (toggle / drawer); dialog footer Save is a no-op on this tab. */
export function createFeedConfigTab(roundsApi: TournamentRoundsApi) {
  return buildFeedConfigTab(createTournamentRoundFeedConfigApi(roundsApi), {
    label: 'Feed update configurations',
  })
}
